<template>
  <div class="login-page">
    <div class="login-panel">
      <div class="login-panel__header">
        <p>STRONGOVA 后台管理</p>
        <h1>登录 Sign in</h1>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-position="top" @submit.native.prevent="handleSubmit">
        <el-form-item label="用户名 Username" prop="username">
          <el-input v-model.trim="form.username" autocomplete="username" />
        </el-form-item>

        <el-form-item label="密码 Password" prop="password">
          <el-input v-model.trim="form.password" type="password" autocomplete="current-password" show-password />
        </el-form-item>

        <el-alert
          v-if="errorMessage"
          :title="errorMessage"
          type="error"
          :closable="false"
          show-icon
          class="login-panel__alert"
        />

        <el-button type="primary" :loading="submitting" class="login-panel__submit" @click="handleSubmit">
          登录 Sign in
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '../api/auth'
import { setSession } from '../utils/auth'

export default {
  name: 'LoginView',
  data () {
    return {
      submitting: false,
      errorMessage: '',
      form: {
        username: 'admin',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名 Please input username.', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码 Please input password.', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid || this.submitting) return

        this.submitting = true
        this.errorMessage = ''

        try {
          const { data } = await login(this.form)
          setSession(data.token, data.admin)
          this.$router.push('/dashboard')
        } catch (error) {
          this.errorMessage = (error.response && error.response.data && error.response.data.message) || '登录失败 Login failed.'
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style>
.login-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background:
    radial-gradient(circle at top right, rgba(183, 139, 95, 0.14), transparent 28%),
    linear-gradient(180deg, #f5f3ef 0%, #ebe5dd 100%);
}

.login-panel {
  width: min(440px, 100%);
  padding: 36px 34px 32px;
  border: 1px solid rgba(23, 20, 17, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 24px 48px rgba(23, 20, 17, 0.08);
}

.login-panel__header p {
  margin: 0 0 10px;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 12px;
}

.login-panel__header h1 {
  margin: 0 0 26px;
  font-size: 30px;
  font-weight: 500;
}

.login-panel__alert {
  margin-bottom: 16px;
}

.login-panel__submit {
  width: 100%;
  margin-top: 6px;
}
</style>
